module.exports = __webpack_public_path__ + "img/6.09cce7c9.png";